export const closeSamplesConfirmDialogStrings = {
    title: 'Schließen',
    message: 'Wenn Sie die Tabelle schließen, gehen Ihre Änderungen verloren. Wollen Sie das?',
    confirmButtonLabel: 'Ok',
    cancelButtonLabel: 'Abbrechen'
};
